import React from 'react'

import Draggable from 'react-draggable';

import { Modal,  ModalDialog } from 'react-bootstrap';

import Profile from '../maintenance/profile'

class DraggableModalDialog extends React.Component {
	render() {
		return <Draggable handle=".modal-header"><ModalDialog {...this.props} /></Draggable>
	}
}

export default function ModalDepartament({showModal, handleCloseModal,editState, data, handleReload}) {

    return (
      
        <Modal size='md' show={showModal} onHide={handleCloseModal} animation={true} backdrop="static"  dialogAs={DraggableModalDialog}>
                <Modal.Header closeButton>
                    <Modal.Title style={{marginBottom:"0px"}}>
                        <i className="fa fa-user"></i> Meu Perfil
                    </Modal.Title>
                </Modal.Header>
            
                <Modal.Body>
                    <div className={`box-shadow`}>               
                        <Profile isModal={true}/>
                    </div>
                </Modal.Body>
        </Modal>
       
    )
}